export default "__VITE_ASSET__D$wukept__"